var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackedBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stacked-bar-chart__Property 1=Stacked Bar Chart",
    className: "stacked-bar-chart__Property stacked-bar-chart__1=Stacked stacked-bar-chart__Bar stacked-bar-chart__Chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stacked-bar-chart__Group 38929",
    className: "stacked-bar-chart__Group stacked-bar-chart__38929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stacked-bar-chart__Vector",
    className: "stacked-bar-chart__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M7.114 5.862H2.62c-.11 0-.2.048-.2.107v9.679c0 .059.09.107.2.107h4.494c.11 0 .2-.048.2-.107V5.969c0-.059-.09-.107-.2-.107Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M2.67 15.505h4.394V6.112H2.67v9.393Zm4.894.142c0 .166-.121.26-.19.297a.555.555 0 0 1-.26.062H2.62a.555.555 0 0 1-.26-.062c-.069-.037-.19-.13-.19-.297V5.97c0-.166.121-.258.19-.296a.554.554 0 0 1 .26-.061h4.494c.088 0 .18.019.26.061.069.038.19.13.19.296v9.678Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M7.314 15.755H2.418v4.795a.2.2 0 0 0 .203.2l4.495-.05a.2.2 0 0 0 .198-.2v-4.745Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "m2.668 20.5 4.395-.05v-4.445H2.668v4.494Zm4.895 0a.45.45 0 0 1-.445.45L2.623 21a.45.45 0 0 1-.455-.45v-5.045h5.395V20.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M14.416 11.202H9.922c-.11 0-.2.025-.2.055v4.926c0 .03.09.054.2.054h4.494c.11 0 .2-.024.2-.054v-4.926c0-.03-.09-.055-.2-.055Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M9.972 15.987h4.394v-4.535H9.972v4.535Zm4.894.196c0 .14-.1.212-.13.231a.41.41 0 0 1-.113.049.808.808 0 0 1-.207.024H9.922a.812.812 0 0 1-.208-.024.409.409 0 0 1-.112-.049.277.277 0 0 1-.13-.231v-4.926c0-.14.1-.212.13-.232a.403.403 0 0 1 .112-.048.812.812 0 0 1 .208-.025h4.494c.07 0 .144.007.207.025.03.008.073.022.113.048.03.02.13.093.13.232v4.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M14.615 16.237H9.72v4.313a.2.2 0 0 0 .202.2l4.495-.045a.2.2 0 0 0 .198-.2v-4.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "m9.97 20.5 4.395-.045v-3.968H9.97V20.5Zm4.895.005a.45.45 0 0 1-.445.45L9.925 21a.45.45 0 0 1-.455-.45v-4.563h5.395v4.518Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M21.718 2.727h-4.495c-.11 0-.2.036-.2.081v7.335c0 .045.09.082.2.082h4.495c.11 0 .2-.037.2-.082V2.808c0-.045-.09-.081-.2-.081Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01277F",
    d: "M17.273 9.975h4.395V2.977h-4.395v6.998Zm4.895.169c0 .1-.052.172-.093.211a.384.384 0 0 1-.122.078.635.635 0 0 1-.235.042h-4.494a.638.638 0 0 1-.237-.042.384.384 0 0 1-.12-.078.295.295 0 0 1-.094-.211V2.808c0-.1.052-.172.093-.211a.386.386 0 0 1 .121-.078.638.638 0 0 1 .237-.042h4.494c.079 0 .162.012.235.042a.37.37 0 0 1 .122.078c.041.04.093.11.093.21v7.337Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M21.917 10.225h-4.896V20.55a.2.2 0 0 0 .206.2l4.495-.105a.2.2 0 0 0 .195-.2v-10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "m17.271 20.498 4.396-.101v-9.922h-4.396v10.023Zm4.896-.052a.45.45 0 0 1-.44.449L17.232 21a.45.45 0 0 1-.46-.45V9.975h5.395v10.47Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChart);
export default __webpack_public_path__ + "static/media/stacked_bar_chart.ae67c06e1ab651ced5c2533c448aa1eb.svg";
export { ForwardRef as ReactComponent };